import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { PALETTE } from '../../../styles/constants'
import Text from '../../Text'
import SimpleBlockContent from '../../SimpleBlockContent'
import ChevronRightIcon from '../../icons/ChevronRightIcon'

function QuotesCarousel({ title, quotes, backgroundColor = { value: PALETTE.gray10 }, textColor = { value: PALETTE.gray80 }, quotesColor, autoplay = { enabled: true, intervalSeconds: 10 } }) {
  const colorProps = { backgroundColor: backgroundColor.value, color: textColor.value }

  const [selectedQuoteIndex, setSelectedQuoteIndex] = useState(0)
  const [autoplayEnabled, setAutoplayEnabled] = useState(autoplay.enabled)

  const showPreviousQuote = () => setSelectedQuoteIndex(selectedQuoteIndex > 0 ? selectedQuoteIndex - 1 : quotes.length - 1)
  const showNextQuote = () => setSelectedQuoteIndex(selectedQuoteIndex < quotes.length - 1 ? selectedQuoteIndex + 1 : 0)

  useEffect(() => {
      if (autoplayEnabled) {
        const id = setInterval(showNextQuote, autoplay.intervalSeconds * 1000)
        return () => clearInterval(id)
      }
    },
    [selectedQuoteIndex, autoplayEnabled]
  )

  return (
    <div
      className={styles.wrapper}
      style={{ backgroundColor: colorProps.backgroundColor, color: colorProps.color }}
      onMouseEnter={() => autoplay.enabled && setAutoplayEnabled(false)}
      onMouseLeave={() => autoplay.enabled && setAutoplayEnabled(true)}
    >
      <div className={styles.titleWrapper}>
        <Text type="h2">{title}</Text>
      </div>
      <div className={styles.carouselIndicators}>
        <div className={styles.leftIndicator} onClick={showPreviousQuote}><ChevronRightIcon/></div>
        <div className={styles.rightIndicator} onClick={showNextQuote}><ChevronRightIcon/></div>
      </div>
      <div className={styles.quotesWrapper}>
        {
          quotes.map((q, i) => (
            <div
              className={styles.quoteWrapper}
              key={q._key}
              style={{ opacity: selectedQuoteIndex === i ? '1' : '0' }}
            >
              <div className={styles.quoteTextWrapper} style={quotesColor && quotesColor.value ? { color: quotesColor.value } : undefined}>
                <SimpleBlockContent blocks={q.text}/>
              </div>
              <Text type="h4">{`— ${q.authorName}`}</Text>
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default QuotesCarousel
